module.exports = __webpack_public_path__ + "img/82800.d4734396.jpg";